import useHashLocation from './useHashLocation';

export interface UseShowVdpProps {
  vehicle: unknown;
}

export type UseShowVdpResult = [boolean, UseShowVdpResultPageDetails];

export interface UseShowVdpResultPageDetails {
  vehicleNotFound?: boolean;
}

export function useShowVdp(props: UseShowVdpProps): UseShowVdpResult {
  const { values } = useHashLocation();

  const urlHasVin = !!values.vin;
  const vehicleFound = !!props.vehicle;

  const showVdp = urlHasVin && vehicleFound;

  return [
    showVdp,
    {
      vehicleNotFound: urlHasVin && !vehicleFound,
    },
  ];
}
